module.exports = __webpack_public_path__ + "static/JL.190415.COH.WEBW.WanchaiLoc-d573b495430ba21b2f7d95e874ef2763.jpg";